<template>
  <div class="wrap">
    <van-popup v-model="show" position="bottom" :close-on-click-overlay="boll">
        <div class="pop">
            <div class="top flex space_between f14">
                <span @click=cancel>取消</span>
                <span class="main_co" @click="confirm">确定</span>
            </div>
            <div class="list">
                <van-checkbox-group v-model="checked">
                      <van-cell
                      clickable
                      @click="add"
                      >
                          <div slot="title" class="title flex flex_start">
                              <img src="../assets/image/hotel/xinzeng.png" alt="">
                              <span>手动新增</span>
                          </div>
                      </van-cell>
                      <van-cell v-for="(item, index) in list" :key="index">
                          <div slot="title" class="title flex flex_start pub_left">
                              <div><img src="../assets/image/hotel/xinzeng.png" alt=""></div>
                              <div>
                                  <p class="f16">张不凡</p>
                                  <p class="f12 gray_f">身份证：4224104568199402182543</p>
                              </div>
                          </div>
                      <van-checkbox
                          :name="item"
                          ref="checkboxes"
                          slot="right-icon"
                           :checked-color="color"
                      />
                      </van-cell>
                </van-checkbox-group>
            </div>
        </div>
    </van-popup>
  </div>
</template>

<script>
export default {
  props: {
    list: Array,
    check: Array,
    show: Boolean
  },
  data () {
    return {
      checked: [],
      color: window.g.main_color,
      boll: false
    }
  },
  methods: {
    // 手动新增
    add () {
      this.$emit('cancel')
      this.$router.push({path: '/add'})
    },
    cancel () {
      this.$emit('cancel')
    },
    confirm (){
      this.$emit('confirm', this.checked)
    }
  }
}
</script>

<style scoped>
    .pop{
        position: relative;
        padding-top: 1.2rem;
    }
    .top{
        line-height: 1.2rem;
        padding: 0 4%;
        position: absolute;
        left: 0;
        top: 0;
        width: 100%
    }
    .list{
      max-height: 50vh;
      overflow: auto;
    }
    img{
        width: .5rem;
        margin-right: .3rem
    }
</style>



// WEBPACK FOOTER //
// src/components/takeperson.vue